import { render, staticRenderFns } from "./CompSurveySlider.vue?vue&type=template&id=3788bcab&"
import script from "./CompSurveySlider.vue?vue&type=script&lang=ts&"
export * from "./CompSurveySlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports